import { SaveDateVersionList } from './verions.js';

export interface ISaveDatePetal {
  petalColor1: string;
  petalColor2: string;
}

export class SaveDatePetal implements ISaveDatePetal {
  petalColor1: string;
  petalColor2: string;

  constructor(petal?: Partial<ISaveDatePetal>) {
    this.petalColor1 = petal?.petalColor1 ?? '#ffffff';
    this.petalColor2 = petal?.petalColor2 ?? '#ffffff';
  }
}

export interface ISaveDateCommon {
  clientId: string;
  version: SaveDateVersionList;
  mainColor: string;
  mainColor2: string;
  backgroundColor: string;
  backgroundColor2: string;
  textFont: string;
  herName: string;
  hisName: string;
  place: string;
  isPetal: boolean;
  petal?: ISaveDatePetal | undefined;
}

export class SaveDateCommonClass implements ISaveDateCommon {
  clientId: string;
  version: SaveDateVersionList;
  mainColor: string;
  mainColor2: string;
  backgroundColor: string;
  backgroundColor2: string;
  textFont: string;
  herName: string;
  hisName: string;
  place: string;
  isPetal: boolean;
  petal?: ISaveDatePetal | undefined;

  constructor(saveDate?: Partial<ISaveDateCommon>) {
    this.clientId = saveDate?.clientId ?? '';
    this.version = saveDate?.version ?? SaveDateVersionList.SAVEDATEV1;
    this.mainColor = saveDate?.mainColor ?? '#000000';
    this.mainColor2 = saveDate?.mainColor2 ?? '#000000';
    this.backgroundColor = saveDate?.backgroundColor ?? '#ffffff';
    this.backgroundColor2 = saveDate?.backgroundColor2 ?? '#ffffff';
    this.textFont = saveDate?.textFont ?? '';
    this.herName = saveDate?.herName ?? '';
    this.hisName = saveDate?.hisName ?? '';
    this.place = saveDate?.place ?? '';
    this.isPetal = saveDate?.isPetal ?? false;

    if (this.isPetal) {
      this.petal = new SaveDatePetal(saveDate?.petal);
    }
  }
}
